import { Link, useLocation } from 'react-router-dom';
import { navCategories } from '@/mocks/navigationData';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const breadcrumbs: BreadcrumbItem[] = [{ label: '首页', to: '/' }];

  if (pathSegments[0] === 'category' && pathSegments[1]) {
    const category = navCategories.find((c) => c.slug === pathSegments[1]);
    breadcrumbs.push({
      label: '分类浏览',
      to: '/category/sousuo-yinqing',
    });
    if (category) {
      breadcrumbs.push({ label: category.name });
    }
  } else if (pathSegments[0] === 'article' && pathSegments[1]) {
    breadcrumbs.push({ label: '文章' });
  } else if (pathSegments[0] === 'about') {
    breadcrumbs.push({ label: '关于我们' });
  }

  if (breadcrumbs.length <= 1) return null;

  return (
    <nav aria-label="面包屑导航" className="max-w-[1400px] mx-auto px-4 md:px-6 pt-20 pb-2">
      <ol className="flex items-center gap-1.5 text-sm flex-wrap">
        {breadcrumbs.map((item, index) => (
          <li key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-sm"></i>
            )}
            {item.to && index < breadcrumbs.length - 1 ? (
              <Link
                to={item.to}
                className="text-foreground-500 hover:text-primary-600 transition-colors duration-200"
              >
                {item.label}
              </Link>
            ) : (
              <span className={index === breadcrumbs.length - 1 ? 'text-foreground-900 font-medium' : 'text-foreground-500'}>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}